import styled, { css } from 'styled-components'

export const TextHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const SavedText = styled.span<{ show: boolean; success: boolean }>`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    10% {
      opacity: 100;
    }
    80% {
      opacity: 100;
    }
    90% {
      opacity: 0;
    }
  }
  color: ${({ success }) =>
    success ? 'var(--tds-positive)' : 'var(--tds-negative)'};

  ${({ show }) =>
    show &&
    css`
      animation-duration: 2.1s;
      animation-name: fadeIn;
      animation-direction: alternate;
      transition-timing-function: cubic-bezier(0.22, 0.61, 0, 1);
    `};
`

export const TranslationItemWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`

export const TranslationTextAreaWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-left: 16px;
  margin-right: 16px;
`

export const AdditionalInfoTitle = styled.h6.attrs({
  className: 'tds-headline-06'
})`
  margin-top: 0;
  margin-bottom: 0;
`

export const AdditionalInfoBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
`

export const AdditionalInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const AdditionalInfoContent = styled.p`
  margin-top: 8px;
  margin-bottom: 8px;
`

export const TranslationNo = styled.h4.attrs({
  className: 'tds-headline-05'
})`
  margin-top: 0;
  margin-left: 4px;
`

export const BaseTranslation = styled.div`
  > :first-child {
    margin-top: 0;
  }

  margin-top: 4px;
  margin-bottom: 12px;
`

export const EmptyBaseTranslation = styled.h5.attrs({
  className: 'tds-headline-05'
})`
  text {
    padding-left: 8px;
    padding-right: 8px;
  }
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 8px;
  background-color: black;
  color: white;
`

export const StyledBlock = styled.div`
  width: 200px;
`
